<template>
  <section class="home">
    <NewsList />
  </section>
</template>

<script>
import { mapState } from "vuex";
import NewsList from "@/components/NewsList";
import EventBus from "@/helpers/event-bus";

export default {
  name: "HomeView",
  components: {
    NewsList,
  },
  props: {
    slug: String,
  },
	computed: {
    ...mapState({
      title: (state) => state.site.title,
		}),
	},
	metaInfo() {
		return {
			title: this.title
		}
	},
	mounted() {
		EventBus.$emit(EventBus.menu.reinit);
	}
};
</script>

<style lang="scss" scoped>
.home {
}
</style>
